export default __webpack_public_path__ + "static/media/BAYC300.ff55f700.png";